module.exports = __webpack_public_path__ + "img/ppt.4ceb64ad.svg";